import { IAnnotation } from "@bronte/viewer-api/src/main";

export type KeyValue = {
  [key: string]: string;
};

export type SpotlightAudio = {
  ttsURL: string;
  wordHighlightColor: string;
  sentenceHighlightColor: string;
  maxSpotlights?: number;
};

export type URLParams = {
  cohortId: string;
  deploymentId: string;
  env: string;
  pocEnabled: string;
  disableIES: string;
  screenId: string;
  userId: string;
  token: string;
  packagePath: string;
};

export enum DrawerTypes {
  TOC,
  SETTINGS,
  NOTEBOOK,
  AUDIOBOOK,
  FLASHCARD,
  SEARCH,
}

export interface IAnnotationData extends IAnnotation {
  actionType?: string;
  screenTitle?: string;
  flashcardFrontText?: string;
  flashcardBackText?: string;
  pageId?: string;
}

export type SpotlightOffsetData = {
  startOffset: number;
  length: number;
};

export type PageNumberData = {
  screenId: string;
  dataId: string;
};
